import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"

export const appConfig: AppConfig<"chromeo"> = {
  appId: "chromeo",
  cookiePrefix: "chromeo",
  lang: "EN",
  admins: {
    mfaEnabled: true,
    otpExpiration: "10 minutes",
    sessionDuration: "30 days"
  },
  artist: {
    name: "Chromeo"
  },
  meta: {
    description: "Chromeo"
  },
  emailSender: {
    name: "Chromeo",
    email: "chromeo@iyk.app"
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/${appConfig.appId}`
      }
    },
    get files() {
      return {
        exclusives: `${appConfig.appId}/exclusives`,
        fanClips: `${appConfig.appId}/fan-clips`,
        merchSkus: `${appConfig.appId}/merch-skus`,
        playlistCoverImages: `${appConfig.appId}/playlist-cover-images`,
        showImages: `${appConfig.appId}/show-images`,
        showCheckInRequestImages: `${appConfig.appId}/check-in-request-images`
      }
    },
    get music() {
      return {
        trackAudios: `${appConfig.appId}/track-audios`,
        playlistDownloadFiles: `${appConfig.appId}/playlist-download-files`
      }
    }
  },
  merch: {
    initialOwnerId: "00000000-0000-0000-0000-000000000000",
    initialOwnerAddress: "0xFeE75BE0ec291d56F7fe4ACd4c7B862EA813D90f"
  },
  tasks: {
    exclusiveLinkDelay: "1 hour"
  },
  checkIn: {
    hidePrompt: true
  },
  shopUrl: null,
  socialLinks: [
    {
      platform: SocialPlatform.Instagram,
      label: "Instagram",
      href: "https://www.instagram.com/chromeo"
    },
    {
      platform: SocialPlatform.TikTok,
      label: "TikTok",
      href: "https://tiktok.com/@Chromeo/"
    },
    {
      platform: SocialPlatform.Youtube,
      label: "YouTube",
      href: "https://www.youtube.com/channel/UCP_4jCsGVDPauX_N5UlhaWw"
    },
    {
      platform: SocialPlatform.Twitter,
      label: "X",
      href: "https://x.com/Chromeo"
    },
    {
      platform: SocialPlatform.Facebook,
      label: "Facebook",
      href: "https://www.facebook.com/chromeo/"
    },
    {
      platform: SocialPlatform.Spotify,
      label: "Spotify",
      href: "https://open.spotify.com/artist/2mV8aJphiSHYJf43DxL7Gt"
    }
  ],
  joinProof: null,
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/og.png`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/logo.png`,
          width: 80
        },
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/logo.png`,
            width: 80
          }
        },
        background: `${appConfig.s3.assets.appUrl}/background.webp`,
        howToTap: null,
        roulette: {
          images: Array.from({ length: 6 }, (_, i) => `${appConfig.s3.assets.vfUrl}/roulette/${i + 1}.webp`)
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: null,
        howToTap: null
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: null,
        artistTermsOfService: null,
        sweepstakeRules: null
      }
    }
  }
}
